import { Dispatch } from 'redux';
import {
    getLeadsSuccess,
    getLeadsFailure,
    getLeadsRequest,
    cleanLeads as cleanLeadsReducer
} from '../reducers/leads';
import { axiosClient } from '../config/axios';
import { api } from '../config/api';
import { catch401 } from '../helpers/actions';
import { GetState } from '../config/store';
import { testMerge } from '../helpers/app';

export const getLeads = (withLoading?: string, startDate?: string, endDate?: string, stringQuery?: any) => (dispatch: Dispatch, getState: GetState) => _getLeads(withLoading, startDate, endDate, stringQuery, dispatch, getState);
const _getLeads = async (withLoading = "", startDate = "", endDate = "", stringQuery = "", dispatch: Dispatch, getState: GetState) => {
    try {
        dispatch({ type: getLeadsRequest, payload: withLoading });
        const searchParams = new URLSearchParams(stringQuery);

        const response = await axiosClient.get(`${api.leads}?startDate=${startDate}&endDate=${endDate}&` + searchParams);

        const parsedInfo = {
            "opportunity": {
                ...response.data.data.opportunity,
                //@ts-ignore
                "leads": testMerge((getState().leads?.leads?.opportunity?.leads || []), response.data.data.opportunity.leads),
            },
            "register": {
                ...response.data.data.register,
                //@ts-ignore
                "leads": testMerge((getState().leads?.leads?.register?.leads || []), response.data.data.register.leads),

            },
            "offer": {
                ...response.data.data.offer,
                //@ts-ignore
                "leads": testMerge((getState().leads?.leads?.offer?.leads || []), response.data.data.offer.leads),

            },
            "scheduling": {
                ...response.data.data.scheduling,
                //@ts-ignore
                "leads": testMerge((getState().leads?.leads?.scheduling?.leads || []), response.data.data.scheduling.leads),

            },
            "match": {
                ...response.data.data.match,
                //@ts-ignore
                "leads": testMerge((getState().leads?.leads?.match?.leads || []), response.data.data.match.leads),

            },
            "referred": {
                ...response.data.data.referred,
                //@ts-ignore
                "leads": testMerge((getState().leads?.leads?.referred?.leads || []), response.data.data.referred.leads),

            },
            "sold": {
                ...response.data.data.sold,
                //@ts-ignore
                "leads": testMerge((getState().leads?.leads?.sold?.leads || []), response.data.data.sold.leads),

            },
            "not_interested": {
                ...response.data.data.not_interested,
                //@ts-ignore
                "leads": testMerge((getState().leads?.leads?.not_interested?.leads || []), response.data.data.not_interested.leads),

            }
        }


        dispatch({ type: getLeadsSuccess, payload: withLoading !== 'reloading' ? response.data.data : parsedInfo });

    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        if (errorResponse?.code) {
            catch401(errorResponse?.code, dispatch);
        } else {
            catch401(error?.error?.statusCode, dispatch);
        }
        dispatch({ type: getLeadsFailure });
    }
};

export const getLeadsByBrand = (withLoading?: string, extraQuery?: any) =>
  async (dispatch: Dispatch, getState: GetState) => {
    try {
      dispatch({ type: getLeadsRequest, payload: withLoading });

      const searchParams = new URLSearchParams({ brand: "true", ...extraQuery });

      const response = await axiosClient.get(`${api.leads}?${searchParams.toString()}`);

      dispatch({ type: getLeadsSuccess, payload: response.data.data });

    } catch (error: any) {
      const errorResponse = error?.response?.data?.error;
      if (errorResponse?.code) {
        catch401(errorResponse?.code, dispatch);
      } else {
        catch401(error?.error?.statusCode, dispatch);
      }
      dispatch({ type: getLeadsFailure });
    }
};

export const cleanLeads = () => (dispatch: Dispatch) => _cleanLeads(dispatch);
const _cleanLeads = async (dispatch: Dispatch) => dispatch({ type: cleanLeadsReducer });